/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable global-require */

import el from '@finn-no/create-element';
import FullscreenDecorator from './fullscreen-decorator';
import ModalOverlay from './modal-overlay';

const FullscreenModalOverlay = FullscreenDecorator(ModalOverlay); // eslint-disable-line new-cap

export default (ele, searchController) => {
    let dialog;
    const inputEle = ele.elements.q;

    function hideDialog() {
        dialog.hide();
    }

    function createDialogContent() {
        const formEle = ele.cloneNode(true);
        formEle.removeAttribute('data-is-dropdown');
        const submitButtonEle = formEle.querySelector('button');
        const newInputEle = formEle.elements.q;
        const buttonEle = el(
            'button.button.button--link.u-ml8',
            {
                type: 'button',
                onclick: hideDialog,
            },
            'Avbryt'
        );

        submitButtonEle.parentNode.replaceChild(buttonEle, submitButtonEle);

        const insertionEle = formEle.querySelector('[data-dropdown-insertion]');
        insertionEle.className = 'r-phl scroll-container u-mv16';
        insertionEle.style.top = '60px';

        // Lots of flashing without this. Which is weird, becuse it's already
        // a layer due to -webkit-overflow-scrolling: touch
        insertionEle.style.webkitTransform = 'translate3d(0, 0, 0)';
        insertionEle.style.transform = 'translate3d(0, 0, 0)';

        if (newInputEle.type === 'search') {
            newInputEle.selectionStart = newInputEle.value.length;
        }

        // The browser ("Internet") on Galaxy S6 has a bug where if one focuses the
        // input before the page has loaded, the fullscreen gets misplaced on load.
        // This might happen on other devices too, but we only work around it on
        // Samsung devices for now.
        // This has the drawback of not popping up the keyboard.
        // TODO: find a better workaround
        if (/samsungbrowser/i.test(navigator.userAgent)) {
            newInputEle.blur();
            window.setTimeout(() => {
                newInputEle.focus();
            });
        }

        return formEle;
    }

    function showFullscreenDialog() {
        if (ModalOverlay.isOpen) {
            return;
        }

        const contentEle = createDialogContent();

        const options = {
            size: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
            },
            onHideFocusElement: ele.querySelector(
                '[data-fullscreen-search-focus]'
            ),
            slideUp: true,
            slideDown: true,
        };

        dialog = new FullscreenModalOverlay('Søk', contentEle, options);
        dialog.show();
        searchController(contentEle);

        contentEle.elements.q.dispatchEvent(new Event('focus'));
    }

    function handle(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        showFullscreenDialog();
    }

    function reset() {
        inputEle.removeEventListener('touchend', handle);
        inputEle.removeEventListener('touchmove', reset);
    }

    // Opening on touchend is faster than focusing the input and then opening, because
    // we can skip at least one layout in the middle of opening the modal.
    // In theory we could use focusin, but that fires after focus in most browsers :(
    inputEle.addEventListener('touchstart', evt => {
        // FIXME: in iOS 10 we have to run preventDefault(), otherwise the input doesn't get focused.
        // This might be a bug. In some Android versions, we can't runt preventDefault(), because
        // the overlay doesn't open at all. Should try to solve this without special-casing iOS.
        if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
            evt.preventDefault();
        }
        inputEle.addEventListener('touchend', handle);
        inputEle.addEventListener('touchmove', reset);
    });

    // The focus event is sometimes triggered by autofocus even if this is done on
    // DOMContentLoaded (bug?). setTimeout() prevents this from happening.
    window.setTimeout(() => {
        inputEle.addEventListener('focus', showFullscreenDialog);
    });

};
